import React, { useState, useEffect, Fragment } from 'react';
import MensajeAdvertencia from '../../Services/MensajeAdvertencia';
import LoaderScreen from '../layout/LoaderScreen';
import Moment from 'moment';
import { ReembolsoSevices } from '../../Services';
import swal from 'sweetalert';

const Paso4 = (props) => {
    const [ActivarLoader, setActivarLoader] = useState(false);
    const [MensajeLoader, setMensajeLoader] = useState("");
    const [FormaPagoC] = useState([2, 8]); // Formas de pago que podrían tener un flujo directo

    // Estados para los datos del receptor y documentos
    const [nombresReceptor, setNombresReceptor] = useState(""); // Renombrado desde Nombres para claridad
    const [apellidosReceptor, setApellidosReceptor] = useState(""); // Renombrado desde Apellidos para claridad
    const [paisOrigenDocReceptor, setPaisOrigenDocReceptor] = useState(""); // Renombrado desde PaisOrigen
    const [tipoDocReceptor, setTipoDocReceptor] = useState(""); // Renombrado desde TipoDocumento
    const [numeroDocReceptor, setNumeroDocReceptor] = useState(""); // Renombrado desde PasajeroDocumento

    const [direccionPagador, setDireccionPagador] = useState("");
    const [esTitularCuenta, setEsTitularCuenta] = useState(true); // True: el pasajero es el titular de la cuenta
    const [habilitarCamposReceptor, setHabilitarCamposReceptor] = useState(false); // True: si el receptor NO es el titular

    // Estados para los archivos adjuntos del titular (si es él mismo el receptor)
    const [docIdentidadTitularFile, setDocIdentidadTitularFile] = useState("");
    const [docIdentidadTitularExt, setDocIdentidadTitularExt] = useState("");
    const [cuentaBancariaTitularFile, setCuentaBancariaTitularFile] = useState("");
    const [cuentaBancariaTitularExt, setCuentaBancariaTitularExt] = useState("");
    const [declaracionJuradaTitularFile, setDeclaracionJuradaTitularFile] = useState("");
    const [declaracionJuradaTitularExt, setDeclaracionJuradaTitularExt] = useState("");

    // Estados para los archivos adjuntos de un tercero (si el receptor NO es el titular)
    const [docIdentidadTerceroFile, setDocIdentidadTerceroFile] = useState("");
    const [docIdentidadTerceroExt, setDocIdentidadTerceroExt] = useState("");
    const [autorizacionTerceroFile, setAutorizacionTerceroFile] = useState("");
    const [autorizacionTerceroExt, setAutorizacionTerceroExt] = useState("");
    // Nota: CuentaBancaria y DeclaracionJurada se reutilizan o necesitan distinción si son del tercero vs. pasajero.
    // Para simplificar, asumiré que CuentaBancariaTitularFile y DeclaracionJuradaTitularFile se usan también para el tercero,
    // pero los documentos de identidad sí son distintos.

    const [aba, setAba] = useState("");
    const [swift, setSwift] = useState("");

    // Errores de validación
    const [errorNombresReceptorMsg, setErrorNombresReceptorMsg] = useState("");
    const [errorApellidosReceptorMsg, setErrorApellidosReceptorMsg] = useState("");

    // Listas para selects
    const [paisesList, setPaisesList] = useState([]); // Renombrado desde Paises
    const [documentosPorPaisList, setDocumentosPorPaisList] = useState([]); // Renombrado

    const [monedaNacional] = useState("VEF");
    const [mostrarCamposAbaSwift, setMostrarCamposAbaSwift] = useState(false); // Renombrado desde ExisteMoneda

    // Estado para saber si el flujo original involucraba un boleto/localizador
    const [flujoConDocumentosPaso1, setFlujoConDocumentosPaso1] = useState(false);


    // FUNCIONES AUXILIARES
    const esSoloTexto = (inputtxt) => /^[A-Za-zÀ-ÿ\s']+$/.test(inputtxt); // Permitir espacios y acentos comunes

    // MANEJO DE CAMBIOS EN INPUTS (RECEPTOR)
    const handleNombresReceptorChange = (valor) => {
        if (valor.length <= 50) {
            setNombresReceptor(valor);
            if (valor.trim() === "") setErrorNombresReceptorMsg("- Campo obligatorio");
            else if (!esSoloTexto(valor)) setErrorNombresReceptorMsg("Debe ingresar solo texto");
            else setErrorNombresReceptorMsg("");
            window.localStorage.setItem("NombresReceptorPaso4", valor); // Usar claves específicas de Paso4
        }
    };

    const handleApellidosReceptorChange = (valor) => {
         if (valor.length <= 50) {
            setApellidosReceptor(valor);
            if (valor.trim() === "") setErrorApellidosReceptorMsg("- Campo obligatorio");
            else if (!esSoloTexto(valor)) setErrorApellidosReceptorMsg("Debe ingresar solo texto");
            else setErrorApellidosReceptorMsg("");
            window.localStorage.setItem("ApellidosReceptorPaso4", valor);
        }
    };

    const handlePaisOrigenDocReceptorChange = (valor) => {
        setPaisOrigenDocReceptor(valor);
        setTipoDocReceptor(""); // Resetear tipo de documento al cambiar país
        setDocumentosPorPaisList([]);
        if (valor) {
            fetchDocumentosPorPais(valor);
            window.localStorage.setItem("ReceptorPaisDocumentoPaso4", valor);
        } else {
            window.localStorage.removeItem("ReceptorPaisDocumentoPaso4");
        }
    };

    const handleTipoDocReceptorChange = (valor) => {
        setTipoDocReceptor(valor);
        if (valor) {
            window.localStorage.setItem("ReceptorTipoDocumentoPaso4", valor);
        } else {
            window.localStorage.removeItem("ReceptorTipoDocumentoPaso4");
        }
    };
    
    const handleNumeroDocReceptorChange = (valor) => {
        if (valor.length <= 20) { // Asumiendo una longitud máxima
            setNumeroDocReceptor(valor);
            window.localStorage.setItem("ReceptorNumeroDocumentoPaso4", valor);
        }
    };
    
    const handleDireccionPagadorChange = (valor) => {
        setDireccionPagador(valor);
        if (valor.length >= 10) { // Validación simple de longitud
            window.localStorage.setItem("DireccionPagadorPaso4", valor);
        } else {
            window.localStorage.removeItem("DireccionPagadorPaso4");
        }
    };

    const handleAbaChange = (valor) => {
        setAba(valor);
        window.localStorage.setItem("AbaPaso4", valor);
    };

    const handleSwiftChange = (valor) => {
        setSwift(valor);
        window.localStorage.setItem("SwiftPaso4", valor);
    };


    // LÓGICA TITULAR DE CUENTA
    const handleEsTitularCuentaChange = (event) => {
        const esTitular = event.target.value === "true";
        setEsTitularCuenta(esTitular);
        window.localStorage.setItem("EsTitularPaso4", esTitular.toString());

        setHabilitarCamposReceptor(!esTitular); // Si es titular, deshabilita (se auto-llenan), sino habilita.

        if (esTitular) {
            // Si es titular, intentar auto-llenar desde datos del pasajero (Paso2)
            const nombresPax = window.localStorage.getItem("NombresPasajeroPaso2") || ""; // Asumiendo clave de Paso2
            const apellidosPax = window.localStorage.getItem("ApellidosPasajeroPaso2") || "";
            const paisDocPax = window.localStorage.getItem("PaisDocumentoPasajeroPaso2") || "";
            const tipoDocPax = window.localStorage.getItem("TipoDocumentoPasajeroPaso2") || "";
            const numDocPax = window.localStorage.getItem("NumeroDocumentoPasajeroPaso2") || "";

            setNombresReceptor(nombresPax);
            setApellidosReceptor(apellidosPax);
            setPaisOrigenDocReceptor(paisDocPax);
            if(paisDocPax) fetchDocumentosPorPais(paisDocPax); // Cargar tipos de doc para el país del pasajero
            setTipoDocReceptor(tipoDocPax);
            setNumeroDocReceptor(numDocPax);

            // Guardar en localStorage para el receptor (ya que son los mismos)
            window.localStorage.setItem("NombresReceptorPaso4", nombresPax);
            window.localStorage.setItem("ApellidosReceptorPaso4", apellidosPax);
            window.localStorage.setItem("ReceptorPaisDocumentoPaso4", paisDocPax);
            window.localStorage.setItem("ReceptorTipoDocumentoPaso4", tipoDocPax);
            window.localStorage.setItem("ReceptorNumeroDocumentoPaso4", numDocPax);

            // Limpiar campos de archivos de tercero
            setDocIdentidadTerceroFile(""); setDocIdentidadTerceroExt("");
            setAutorizacionTerceroFile(""); setAutorizacionTerceroExt("");
        } else {
            // Si NO es titular, limpiar campos del receptor para ingreso manual
            setNombresReceptor(""); setErrorNombresReceptorMsg("");
            setApellidosReceptor(""); setErrorApellidosReceptorMsg("");
            setPaisOrigenDocReceptor("");
            setTipoDocReceptor("");
            setNumeroDocReceptor("");
            setDocumentosPorPaisList([]);
            // Limpiar también los localStorage correspondientes al receptor
            ["NombresReceptorPaso4", "ApellidosReceptorPaso4", "ReceptorPaisDocumentoPaso4", "ReceptorTipoDocumentoPaso4", "ReceptorNumeroDocumentoPaso4"].forEach(key => window.localStorage.removeItem(key));
        }
    };


    // CARGA DE DATOS ASÍNCRONOS
    async function fetchPaises() {
        try {
            setActivarLoader(true); setMensajeLoader("Cargando países...");
            const peticion = await ReembolsoSevices.ObtenerPaises();
            if (peticion.status === 200 && peticion.resp) {
                setPaisesList(peticion.resp);
            } else {
                MensajeAdvertencia("Error", "No se pudieron cargar los países.", "error", "Ok");
            }
        } catch (error) {
            MensajeAdvertencia("Error de Red", `Ocurrió un error al cargar países: ${error.message}`, "error", "Ok");
        } finally {
            setActivarLoader(false);
        }
    }

    async function fetchDocumentosPorPais(idPais) {
        if (!idPais) return;
        try {
            setActivarLoader(true); setMensajeLoader("Cargando tipos de documento...");
            const peticion = await ReembolsoSevices.ObtenerDocumentosPorPaises(idPais);
            if (peticion.status === 200 && peticion.resp) {
                setDocumentosPorPaisList(peticion.resp);
            } else {
                 setDocumentosPorPaisList([]); // Limpiar si no hay respuesta o hay error
            }
        } catch (error) {
             MensajeAdvertencia("Error de Red", `Ocurrió un error al cargar tipos de documento: ${error.message}`, "error", "Ok");
        } finally {
            setActivarLoader(false);
        }
    }

    // LÓGICA DE INICIALIZACIÓN (useEffect)
    useEffect(() => {
         const elem = document.querySelector('._3uApM');
    if (elem) {
        elem.style.display = 'none';
    }
        
        setActivarLoader(true);
        // Determinar si el flujo general viene con boleto/localizador desde Paso 1
        const tieneDocumentosGlobal = window.localStorage.getItem("TieneDocumentos") === "true";
        setFlujoConDocumentosPaso1(tieneDocumentosGlobal);

        // Lógica de formas de pago que podrían saltar este paso
        const formaPagoStorage = window.localStorage.getItem("FormaPago"); // Asumo esta clave de un paso anterior
        let esFormaPagoDirecta = false;
        if (formaPagoStorage) {
            esFormaPagoDirecta = FormaPagoC.some(fp => fp.toString() === formaPagoStorage);
        }

        // if (esFormaPagoDirecta) {
        //     setMensajeLoader("Procesando directamente...");
        //     // Simular clic para avanzar (si es la intención) y procesar
        //     // Esta manipulación directa del DOM es riesgosa. Considerar un estado global o callback.
        //     // const btnSiguiente = document.querySelector('._3CDiP'); // Clase del botón "Siguiente" de StepProgressBar
        //     // if(btnSiguiente) btnSiguiente.click();
        //     ProcesarReembolso(); // Llamar a procesar
        // } else {
            // Flujo normal para Paso 4
            fetchPaises(); // Cargar lista de países

            // Restaurar estado de "EsTitularCuenta"
            const esTitularGuardado = window.localStorage.getItem("EsTitularPaso4") === "true";
            setEsTitularCuenta(esTitularGuardado);
            setHabilitarCamposReceptor(!esTitularGuardado);

            if (esTitularGuardado) {
                // Si era titular, cargar sus datos guardados (que eran los del pasajero)
                setNombresReceptor(window.localStorage.getItem("NombresReceptorPaso4") || "");
                setApellidosReceptor(window.localStorage.getItem("ApellidosReceptorPaso4") || "");
                const paisGuardado = window.localStorage.getItem("ReceptorPaisDocumentoPaso4") || "";
                setPaisOrigenDocReceptor(paisGuardado);
                if (paisGuardado) fetchDocumentosPorPais(paisGuardado);
                setTipoDocReceptor(window.localStorage.getItem("ReceptorTipoDocumentoPaso4") || "");
                setNumeroDocReceptor(window.localStorage.getItem("ReceptorNumeroDocumentoPaso4") || "");
            } else {
                 // Si no era titular, cargar los datos del receptor ingresados manualmente
                setNombresReceptor(window.localStorage.getItem("NombresReceptorPaso4") || "");
                setApellidosReceptor(window.localStorage.getItem("ApellidosReceptorPaso4") || "");
                const paisGuardado = window.localStorage.getItem("ReceptorPaisDocumentoPaso4") || "";
                setPaisOrigenDocReceptor(paisGuardado);
                if (paisGuardado) fetchDocumentosPorPais(paisGuardado);
                setTipoDocReceptor(window.localStorage.getItem("ReceptorTipoDocumentoPaso4") || "");
                setNumeroDocReceptor(window.localStorage.getItem("ReceptorNumeroDocumentoPaso4") || "");
            }
            
            setDireccionPagador(window.localStorage.getItem("DireccionPagadorPaso4") || "");
            setAba(window.localStorage.getItem("AbaPaso4") || "");
            setSwift(window.localStorage.getItem("SwiftPaso4") || "");

            // Determinar si mostrar campos ABA/SWIFT
            const monedaActual = window.localStorage.getItem("Moneda"); // Asumo esta clave de un paso anterior
            const formaPagoActual = window.localStorage.getItem("FormaPago");
            if (monedaActual && monedaActual !== monedaNacional && formaPagoActual !== "5" && formaPagoActual !== "2") {
                setMostrarCamposAbaSwift(true);
            } else {
                setMostrarCamposAbaSwift(false);
            }
        // }
        setActivarLoader(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Se ejecuta solo al montar


    // MANEJO DE ARCHIVOS (sin cambios mayores, solo nombres de estado)
    const handleFileRead = (event, setFileState, setFileExtState) => {
        const file = event.target.files[0];
        if (!file) return;

        const fileName = file.name;
        const fileSizeMB = file.size / 1024 / 1024;
        const fileExtension = fileName.split('.').pop().toLowerCase();

        if (fileSizeMB > 0.5) {
            MensajeAdvertencia("Advertencia", "El archivo no debe superar los 500Kb.", "warning", "Reintentar");
            event.target.value = null; // Limpiar el input file
            return;
        }
        if (!['pdf', 'jpg', 'jpeg'].includes(fileExtension)) {
            MensajeAdvertencia("Advertencia", "El formato del archivo debe ser PDF o JPG/JPEG.", "warning", "Reintentar");
            event.target.value = null;
            return;
        }

        setFileExtState(fileExtension);
        const reader = new FileReader();
        reader.onload = (e) => setFileState(btoa(e.target.result));
        reader.readAsBinaryString(file);
    };


    // FUNCIÓN PARA PROCESAR EL REEMBOLSO (Ajustes mínimos en la lectura de TieneDocumentos)
    async function ProcesarReembolso() {
        setActivarLoader(true);
        setMensajeLoader("Procesando reembolso...");

        // Leer directamente de localStorage como en tu código original, pero ajustando "TieneDocumentos"
        const tieneDocumentos = window.localStorage.getItem("TieneDocumentos") === "true";
        const formaPago = window.localStorage.getItem("FormaPago");
        const esTitularStorage = window.localStorage.getItem("EsTitularPaso4") === "true"; // Leer el estado de este paso
        const moneda = window.localStorage.getItem("Moneda");
        const motivoId = window.localStorage.getItem("Motivo");
        const observaciones = window.localStorage.getItem("Observaciones");
        const correoSolicitante = window.localStorage.getItem("Correo"); // Asumo de Paso2 o similar
        
        // Datos del boleto/localizador (¡ADVERTENCIA SOBRE ESTA SECCIÓN!)
        // Paso1 ahora guarda esto en una cadena compleja en localStorage.getItem("Boleto").
        // La lógica actual de ProcesarReembolso no parsea esa cadena.
        // Se necesitaría una función para extraer numTicket, DateBoleto, etc., de esa cadena.
        // Por ahora, se usa como estaba, lo cual puede ser incorrecto.
        const infoBoletoPaso1 = window.localStorage.getItem("Boleto"); // Esta es la cadena compleja
        // Ejemplo de cómo podrías empezar a parsear (necesita robustez):
        let numTicket = null, dateBoleto = null, tipoDocP1 = null, locP1 = null;
        if (infoBoletoPaso1) {
            const dataP1 = {};
            infoBoletoPaso1.split('; ').forEach(part => {
                const [key, ...valueParts] = part.split(':');
                dataP1[key] = valueParts.join(':');
            });
            tipoDocP1 = dataP1.Tipo;
            if(tipoDocP1 === 'ticket') numTicket = dataP1.TicketNro !== 'N/A' ? dataP1.TicketNro : null;
            if(tipoDocP1 === 'localizador') locP1 = dataP1.Loc !== 'N/A' ? dataP1.Loc : null; // Podrías usar locP1 en lugar de numTicket si es localizador
            if(dataP1.Fecha !== 'N/A') dateBoleto = dataP1.Fecha;
            // Si el tipo es localizador y se especificaron tickets, numTicket podría ser dataP1.Tickets
        }
        // Si es un localizador con múltiples tickets, `numTicket` debería ser la lista concatenada o el primer ticket.
        // La lógica original usaba `numTicket` como el identificador principal. Si es localizador, quizás se usa `locP1`.
        // Esto depende de lo que espere tu backend. Para el ejemplo, si hay locP1 y no numTicket, usaré locP1.
        const identificadorPrincipal =  window.localStorage.getItem("Boleto"); // Fallback a la lectura original si el parseo falla o es localizador

        // Datos del pasajero (asumo de Paso2 o similar)
        const nombresPax = window.localStorage.getItem("NombresPasajeroPaso2") || "N/A";
        const apellidosPax = window.localStorage.getItem("ApellidosPasajeroPaso2") || "N/A";
        const origenVuelo = window.localStorage.getItem("OrigenVueloPaso2") || "N/A";
        const destinoVuelo = window.localStorage.getItem("DestinoVueloPaso2") || "N/A";
        const tipoPasajero = window.localStorage.getItem("TipoPasajeroPaso2") || "N/A";

        // Datos del receptor (de este paso, Paso4)
        const nomReceptor = nombresReceptor || (esTitularStorage ? nombresPax : "N/A");
        const apeReceptor = apellidosReceptor || (esTitularStorage ? apellidosPax : "N/A");
        const paisDocRecep = paisOrigenDocReceptor || "N/A";
        const tipoDocRecep = tipoDocReceptor || "N/A";
        const numDocRecep = numeroDocReceptor || "N/A";
        const dirPagador = direccionPagador || "N/A";
        const codAba = aba || "N/A";
        const codSwift = swift || "N/A";


        let esFormaPagoDirecta = false;
        if (formaPago) {
            esFormaPagoDirecta = FormaPagoC.some(fp => fp.toString() === formaPago);
        }
        
        // VALIDACIONES (similar a tu lógica original)
        if (!esFormaPagoDirecta) { // Solo validar si no es PayPal o TC (que se saltan este formulario)
            if (!nomReceptor || nomReceptor === "N/A" || nomReceptor.trim() === "") { MensajeAdvertencia("Advertencia", "Debe indicar el nombre del receptor.", "warning", "Ok"); setActivarLoader(false); return; }
            if (!apeReceptor || apeReceptor === "N/A" || apeReceptor.trim() === "") { MensajeAdvertencia("Advertencia", "Debe indicar el apellido del receptor.", "warning", "Ok"); setActivarLoader(false); return; }
            if (!paisDocRecep || paisDocRecep === "N/A") { MensajeAdvertencia("Advertencia", "Debe seleccionar el origen del documento del receptor.", "warning", "Ok"); setActivarLoader(false); return; }
            if (!tipoDocRecep || tipoDocRecep === "N/A") { MensajeAdvertencia("Advertencia", "Debe indicar el tipo de documento del receptor.", "warning", "Ok"); setActivarLoader(false); return; }
            if (!numDocRecep || numDocRecep === "N/A" || numDocRecep.trim() === "") { MensajeAdvertencia("Advertencia", "Debe indicar el documento del receptor.", "warning", "Ok"); setActivarLoader(false); return; }
            if (!dirPagador || dirPagador === "N/A" || dirPagador.length < 10) { MensajeAdvertencia("Advertencia", "Debe indicar una dirección válida para el titular de la cuenta (mínimo 10 caracteres).", "warning", "Ok"); setActivarLoader(false); return; }

            if (mostrarCamposAbaSwift) { // Si es moneda extranjera y no Zelle/TC
                if ((!codAba || codAba === "N/A" || codAba.trim() === "") && (!codSwift || codSwift === "N/A" || codSwift.trim() === "")) {
                    MensajeAdvertencia("Advertencia", "Debe indicar el código ABA o el código SWIFT para transacciones internacionales.", "warning", "Ok");
                    setActivarLoader(false); return;
                }
            }

            // Validación de archivos adjuntos
            if (esTitularStorage) { // Es el mismo pasajero
                if (!docIdentidadTitularFile) { MensajeAdvertencia("Advertencia", "Debe adjuntar el documento de identidad del titular.", "warning", "Ok"); setActivarLoader(false); return; }
                if (!cuentaBancariaTitularFile) { MensajeAdvertencia("Advertencia", "Debe adjuntar el soporte de la cuenta bancaria del titular.", "warning", "Ok"); setActivarLoader(false); return; }
                if (!declaracionJuradaTitularFile) { MensajeAdvertencia("Advertencia", "Debe adjuntar la declaración jurada del titular.", "warning", "Ok"); setActivarLoader(false); return; }
            } else { // Es un tercero
                if (!docIdentidadTerceroFile) { MensajeAdvertencia("Advertencia", "Debe adjuntar el documento de identidad del tercero.", "warning", "Ok"); setActivarLoader(false); return; }
                if (!autorizacionTerceroFile) { MensajeAdvertencia("Advertencia", "Debe adjuntar la autorización del tercero.", "warning", "Ok"); setActivarLoader(false); return; }
                if (!cuentaBancariaTitularFile) { MensajeAdvertencia("Advertencia", "Debe adjuntar el soporte de la cuenta bancaria del tercero.", "warning", "Ok"); setActivarLoader(false); return; } // Asumiendo que se reutiliza el estado
                if (!docIdentidadTitularFile) { MensajeAdvertencia("Advertencia", "Debe adjuntar el documento de identidad del pasajero (solicitante).", "warning", "Ok"); setActivarLoader(false); return; } // Doc del pasajero
                if (!declaracionJuradaTitularFile) { MensajeAdvertencia("Advertencia", "Debe adjuntar la declaración jurada (firmada por el pasajero).", "warning", "Ok"); setActivarLoader(false); return; } // DJ del pasajero
            }
        }
        // Fin Validaciones

        const requestPayload = {
            isClaim: "0",
            ClaimDetail: { /* ... */ },
            isComplaint: "0",
            ComplaintDetail: { /* ... */ },
            withTicket: tieneDocumentos ? 1 : 0, // Ajustado
            TicketDetail: {
                numTicket: identificadorPrincipal, // Usar el identificador parseado o de fallback
                Date: dateBoleto ? Moment(dateBoleto).toISOString() : Moment().toISOString(), // Usar fecha parseada
                Origin: origenVuelo,
                Destination: destinoVuelo,
                NamePAX: nombresPax,
                LastNamePAX: apellidosPax,
                TypePAX: tipoPasajero,
            },
            CurrencyID: moneda,
            ReasonID: motivoId,
            Comment: observaciones,
            Payers: [{
                Name: nombresPax, // Solicitante original
                LastName: apellidosPax,
                Email: correoSolicitante,
                PaymentMethodID: formaPago,
                Supports: [ // Filtrar los que tienen archivo
                    ...(autorizacionTerceroFile ? [{ ID: 17, Description: "Autorización de tercero", File: autorizacionTerceroFile, FileExt: autorizacionTerceroExt }] : []),
                    ...(docIdentidadTerceroFile ? [{ ID: 1, Description: "Identidad de tercero", File: docIdentidadTerceroFile, FileExt: docIdentidadTerceroExt }] : []),
                    ...(docIdentidadTitularFile ? [{ ID: 19, Description: "Documento de identidad (Pasajero/Titular)", File: docIdentidadTitularFile, FileExt: docIdentidadTitularExt }] : []),
                    ...(cuentaBancariaTitularFile ? [{ ID: 3, Description: "Cuenta bancaria (Receptor)", File: cuentaBancariaTitularFile, FileExt: cuentaBancariaTitularExt }] : []),
                    ...(declaracionJuradaTitularFile ? [{ ID: 20, Description: "Declaración jurada (Pasajero)", File: declaracionJuradaTitularFile, FileExt: declaracionJuradaTitularExt }] : []),
                ].filter(support => support.File && support.FileExt),
            }],
            Receiver: {
                isPassenger: esTitularStorage ? 1 : 0,
                Name: nomReceptor,
                LastName: apeReceptor,
                DOCCountry: paisDocRecep,
                DOCType: tipoDocRecep,
                DOCNumber: numDocRecep,
                Email: correoSolicitante, // O un email específico del receptor si se pide
                Address: dirPagador,
                Aba: codAba !== "N/A" ? codAba : "", // Enviar vacío si es N/A
                Swift: codSwift !== "N/A" ? codSwift : "",
                Currency: moneda,
                // Los "Supports" del Receiver son usualmente los mismos que los del Payer si el Payer es el Pasajero
                // y el Receiver es el Pasajero o un Tercero con autorización del Pasajero.
                // Tu estructura original los duplicaba, lo cual es válido si el backend lo espera así.
                // Por simplicidad, los he dejado principalmente bajo "Payers" que sería el solicitante.
                // Si el backend requiere los mismos adjuntos bajo "Receiver", duplícalos aquí.
                Supports: [/* ... similar a Payers.Supports si es necesario ... */],
            }
        };
        
        console.log("Request Payload:", JSON.stringify(requestPayload));

        try {
            const peticion = await ReembolsoSevices.ProcesarReembolso(JSON.stringify(requestPayload));
            if (peticion.status === 200) {
                if (!peticion.resp.includes("ERROR")) {
                    swal({
                        title: "Solicitud generada con éxito",
                        text: `Hemos registrado su requerimiento de reembolso ${peticion.resp}. Este número de identificación ha sido enviado a su correo electrónico. Con él podrá consultar el estado de su solicitud.`,
                        icon: "success",
                        buttons: {
                            cancel: "Solicitar otro reembolso",
                            catch: { text: "Salir", value: "salir" },
                        }
                    }).then((value) => {
                        window.localStorage.clear(); // Limpiar para nueva solicitud o salida
                        if (value === "salir") {
                            window.location.href = "https://aviorair.com"; // URL de salida
                        } else {
                            window.location.href = "/solicitar"; // URL para nueva solicitud
                        }
                    });
                } else {
                    // Manejo de error del backend
                     swal({
                        title: "Advertencia",
                        text: `Ocurrió un error al realizar la solicitud: ${peticion.resp}`,
                        icon: "warning",
                        buttons: {
                            cancel: "Salir",
                            catch: { text: "Revisar y reintentar", value: "reintentar" },
                        }
                    }).then((value) => {
                        if (value !== "reintentar") {
                            window.localStorage.clear();
                            window.location.href = "/"; 
                        }
                        // Si es "reintentar", el usuario permanece en la página.
                    });
                }
            } else {
                 MensajeAdvertencia("Error de Comunicación", `Error ${peticion.status} al procesar la solicitud.`, "error", "Reintentar");
            }
        } catch (error) {
            MensajeAdvertencia("Error Crítico", `Ocurrió un error inesperado: ${error.message}`, "error", "Reintentar");
        } finally {
            setActivarLoader(false);
        }
    }


    return (
        <>
            <LoaderScreen props={ActivarLoader} mensaje={MensajeLoader} />
            <div className="_pt-30">
                <div className="theme-page-section-header _ta-l">
                    <h5 className="theme-page-section-title">Consignación de documentos</h5>
                    <h5 className="feature-subtitle _op-06">Todos los campos habilitados y marcados con asteriscos (*) son obligatorios.</h5>
                    <hr className="style-3"></hr>
                </div>
                <div className="row row-col-gap " data-gutter="20">
                    <div className="col-md-12 ">
                        <h5 className=" _c-dark"><span className="_c-p">*</span> ¿La cuenta bancaria para el reembolso pertenece al pasajero solicitante?</h5>
                        <div className="theme-payment-page-form-item form-group">
                            <div className="theme-account-notifications-item seleccionable">
                                <div onChange={handleEsTitularCuentaChange}>
                                    <input type="radio" value="true" name="perteneceCuenta" defaultChecked={esTitularCuenta} checked={esTitularCuenta === true} /> Sí
                                    <br/>
                                    <input type="radio" value="false" name="perteneceCuenta" defaultChecked={!esTitularCuenta} checked={esTitularCuenta === false} /> No
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-12">
                        <div className="theme-page-section-header _ta-l _pt-20">
                            <h5 className="theme-page-section-title" style={{ fontSize: "28px" }}>Datos del Receptor del Reembolso</h5>
                            <h5 className="feature-subtitle _op-06">
                                {esTitularCuenta ? "Los datos del pasajero solicitante se usarán como receptor." : "Ingrese los datos de la persona que recibirá el reembolso."}
                            </h5>
                            <hr className="style-3"></hr>
                        </div>
                    </div>

                    <div className="col-md-6 ">
                        <h5 className=" _c-dark"><span className="_c-p">*</span> Nombre(s) del receptor <span className=" _c-p">{errorNombresReceptorMsg}</span></h5>
                        <div className="theme-payment-page-form-item form-group">
                            <input
                                value={nombresReceptor}
                                onChange={(e) => handleNombresReceptorChange(e.target.value)}
                                className="form-control"
                                type="text"
                                placeholder="Nombre(s)"
                                // disabled={esTitularCuenta && habilitarCamposReceptor === false} // Deshabilitado si es titular y se auto-llena
                            />
                        </div>
                    </div>
                     <div className="col-md-6 ">
                        <h5 className=" _c-dark"><span className="_c-p">*</span> Apellido(s) del receptor <span className=" _c-p">{errorApellidosReceptorMsg}</span></h5>
                        <div className="theme-payment-page-form-item form-group">
                             <input
                                value={apellidosReceptor}
                                onChange={(e) => handleApellidosReceptorChange(e.target.value)}
                                className="form-control"
                                type="text"
                                placeholder="Apellido(s)"
                                // disabled={esTitularCuenta && habilitarCamposReceptor === false}
                            />
                        </div>
                    </div>

                    <div className="col-md-4 ">
                        <h5 className=" _c-dark"><span className="_c-p">*</span> Origen del documento del receptor</h5>
                        <div className="theme-payment-page-form-item form-group">
                            <i className="fa fa-angle-down"></i>
                            <select 
                                className="form-control seleccionable"
                                value={paisOrigenDocReceptor}
                                onChange={(e) => handlePaisOrigenDocReceptorChange(e.target.value)}
                                // disabled={esTitularCuenta && habilitarCamposReceptor === false}
                            >
                                <option value="">Seleccione País</option>
                                {paisesList && paisesList.length > 0 && paisesList.map(pais => (
                                    <option key={pais.ID} value={pais.ID}>{pais.Description}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="col-md-4 ">
                        <h5 className=" _c-dark"><span className="_c-p">*</span> Tipo de documento del receptor</h5>
                         <div className="theme-payment-page-form-item form-group">
                            <i className="fa fa-angle-down"></i>
                            <select 
                                className="form-control seleccionable"
                                value={tipoDocReceptor}
                                onChange={(e) => handleTipoDocReceptorChange(e.target.value)}
                            //   disabled={((esTitularCuenta && habilitarCamposReceptor === false) || !paisOrigenDocReceptor)}

                            >
                                <option value="">Seleccione Tipo</option>
                                {documentosPorPaisList && documentosPorPaisList.length > 0 && documentosPorPaisList.map(doc => (
                                    <option key={doc.ID} value={doc.ID}>{doc.Description}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                     <div className="col-md-4 ">
                        <h5 className=" _c-dark"><span className="_c-p">*</span> Número de documento del receptor</h5>
                        <div className="theme-payment-page-form-item form-group">
                            <input
                                value={numeroDocReceptor}
                                onChange={(e) => handleNumeroDocReceptorChange(e.target.value)}
                                className="form-control"
                                type="text"
                                placeholder="Número de Documento"
                                // disabled={esTitularCuenta && habilitarCamposReceptor === false}
                            />
                        </div>
                    </div>

                    <div className="col-md-12 _pt-25">
                        <h5 className=" _c-dark"><span className="_c-p">*</span> Dirección del titular de la cuenta bancaria</h5>
                        <div className="theme-payment-page-form-item form-group text-right">
                            <input
                                value={direccionPagador}
                                onChange={(e) => handleDireccionPagadorChange(e.target.value)}
                                className="form-control"
                                type="text"
                                placeholder="País, estado, ciudad, avenida, calle, etc."
                            />
                            <span>Indispensable indicar la dirección completa.</span>
                        </div>
                    </div>

                    {mostrarCamposAbaSwift && (
                        <div className="col-md-12 _pt-25">
                            <div className="row">
                                <div className="col-md-6 ">
                                    <h5 className=" _c-dark">ABA / Routing <small>(si aplica)</small></h5>
                                    <div className="theme-payment-page-form-item form-group">
                                        <input
                                            onChange={(e) => handleAbaChange(e.target.value)}
                                            className="form-control" type="text" placeholder="ABA / Routing"
                                            value={aba}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <h5 className=" _c-dark">SWIFT <small>(si aplica)</small></h5>
                                    <div className="theme-payment-page-form-item form-group">
                                        <input
                                            onChange={(e) => handleSwiftChange(e.target.value)}
                                            className="form-control" type="text" placeholder="SWIFT"
                                            value={swift}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <small>Estos campos son requeridos para transferencias a bancos internacionales (excepto Zelle y algunas tarjetas).</small>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* SECCIÓN DE DOCUMENTOS ADJUNTOS */}
                    <div className="col-md-12 _pt-25">
                        <h5 className=" _c-dark"><span className="_c-p">*</span> Documentos a consignar <small>En formato *<b>PDF/JPG/JPEG</b>* (máx. 500Kb por archivo)</small></h5>
                        
                        {!esTitularCuenta && ( // Documentos específicos si el receptor es un tercero
                            <Fragment>
                                <div className="theme-search-results-item _mb-10 _b-n theme-search-results-item-rounded p-3">
                                    <h6>Documentos del Tercero (Receptor del reembolso)</h6>
                                    <div className="row">
                                        <div className="col-md-6 _pt-10">
                                            <h5 className="_c-dark"><span className="_c-p">*</span> Doc. Identidad del Tercero</h5>
                                            <input type="file" accept="image/jpeg,application/pdf"
                                                onChange={(e) => handleFileRead(e, setDocIdentidadTerceroFile, setDocIdentidadTerceroExt)} />
                                        </div>
                                        <div className="col-md-6 _pt-10">
                                            <h5 className="_c-dark"><span className="_c-p">*</span> Autorización a Tercero</h5>
                                            <input type="file" accept="image/jpeg,application/pdf"
                                                onChange={(e) => handleFileRead(e, setAutorizacionTerceroFile, setAutorizacionTerceroExt)} />
                                            {/* Enlaces a formatos de autorización */}
                                            <small><b><a className="hover-Oscuro _c-p" target={'_Blank'} rel="noopener noreferrer" href={`${process.env.PUBLIC_URL}/Descargas/nuevas/CARTA DE AUTORIZACIÓN A TERCERO (V1.0).pdf`}>Descargar formato general.</a></b></small><br/>
                                            {/* ... otros formatos si los tienes ... */}
                                        </div>
                                        <div className="col-md-6 _pt-10">
                                            <h5 className="_c-dark"><span className="_c-p">*</span> Soporte Cuenta Bancaria del Tercero</h5>
                                            <input type="file" accept="image/jpeg,application/pdf"
                                                 onChange={(e) => handleFileRead(e, setCuentaBancariaTitularFile, setCuentaBancariaTitularExt)} /> {/* Reutilizando estado por simplicidad */}
                                        </div>
                                    </div>
                                </div>
                                 <div className="theme-search-results-item _mb-10 _b-n theme-search-results-item-rounded p-3 mt-3">
                                     <h6>Documentos del Pasajero Solicitante (cuando el receptor es un tercero)</h6>
                                     <div className="row">
                                        <div className="col-md-6 _pt-10">
                                            <h5 className="_c-dark"><span className="_c-p">*</span> Doc. Identidad del Pasajero</h5>
                                            <input type="file" accept="image/jpeg,application/pdf"
                                                 onChange={(e) => handleFileRead(e, setDocIdentidadTitularFile, setDocIdentidadTitularExt)} />
                                        </div>
                                         <div className="col-md-6 _pt-10">
                                            <h5 className="_c-dark"><span className="_c-p">*</span> Declaración Jurada (firmada por el Pasajero)</h5>
                                            <input type="file" accept="image/jpeg,application/pdf"
                                                 onChange={(e) => handleFileRead(e, setDeclaracionJuradaTitularFile, setDeclaracionJuradaTitularExt)} />
                                            <small><b><a className="hover-Oscuro _c-p" target={'_Blank'} rel="noopener noreferrer" href={`${process.env.PUBLIC_URL}/Descargas/nuevas/CARTA DE DECLARACIÓN JURADA (V1.0).pdf`}>Descargar formato.</a></b></small>
                                        </div>
                                     </div>
                                 </div>
                            </Fragment>
                        )}

                        {esTitularCuenta && ( // Documentos si el receptor es el mismo pasajero solicitante
                             <div className="theme-search-results-item _mb-10 _b-n theme-search-results-item-rounded p-3">
                                <h6>Documentos del Pasajero Titular</h6>
                                <div className="row">
                                    <div className="col-md-6 _pt-10">
                                        <h5 className="_c-dark"><span className="_c-p">*</span> Doc. Identidad del Pasajero</h5>
                                        <input type="file" accept="image/jpeg,application/pdf"
                                            onChange={(e) => handleFileRead(e, setDocIdentidadTitularFile, setDocIdentidadTitularExt)} />
                                    </div>
                                    <div className="col-md-6 _pt-10">
                                        <h5 className="_c-dark"><span className="_c-p">*</span> Soporte Cuenta Bancaria del Pasajero</h5>
                                        <input type="file" accept="image/jpeg,application/pdf"
                                            onChange={(e) => handleFileRead(e, setCuentaBancariaTitularFile, setCuentaBancariaTitularExt)} />
                                    </div>
                                     <div className="col-md-6 _pt-10">
                                        <h5 className="_c-dark"><span className="_c-p">*</span> Declaración Jurada (firmada por el Pasajero)</h5>
                                        <input type="file" accept="image/jpeg,application/pdf"
                                            onChange={(e) => handleFileRead(e, setDeclaracionJuradaTitularFile, setDeclaracionJuradaTitularExt)} />
                                        <small><b><a className="hover-Oscuro _c-p" target={'_Blank'} rel="noopener noreferrer" href={`${process.env.PUBLIC_URL}/Descargas/nuevas/CARTA DE DECLARACIÓN JURADA (V1.0).pdf`}>Descargar formato.</a></b></small>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                <div className="row _pt-50">
                    <div className="col-md-12 text-center">
                        <button onClick={ProcesarReembolso} className="seleccionable theme-search-area-submit _mt-0 theme-search-area-submit-no-border theme-search-area-submit-no-border2 theme-search-area-submit-curved theme-search-area-submit-primary" type="button">
                            Realizar solicitud
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Paso4;